<template>
<div>
    <el-table :row-class-name="tableRowClassName" :data="tableData" style="width: 100%" :show-header="false" @row-click="handleRowSelect">
        <el-table-column width="58">
            <template slot-scope="scope">
                <div class="radio-bank">
                    <el-radio :class="`${getPrimaryColor} d-flex align-items-center mb-0`" v-model="radio" :label="scope.row.id" @change="handleChange(scope.row)" />
                </div>
            </template>
        </el-table-column>
        <el-table-column width="50">
            <template slot-scope="scope">
                <AlertCheckingAccount :name="scope.row.bank" small />
            </template>
        </el-table-column>
        <el-table-column min-width="150">
            <template slot-scope="scope">
                <!-- <el-radio :class="`${getPrimaryColor} d-flex align-items-center mb-0`" v-model="radio" :label="scope.row.id" @change="handleChange(scope.row)"> -->
                <div class="mr-3 d-flex align-items-center">
                    <!-- <AlertCheckingAccount :name="scope.row.bank" small /> -->
                    <p class="c-ndarkfour medium break d-inline-block">
                        {{ bankName(scope.row.bank) | formatName }}
                    </p>
                </div>
                <!-- </el-radio> -->
            </template>
        </el-table-column>
        <el-table-column min-width="90">
            <template slot-scope="scope">
                <div class="d-flex align-items-center">
                    <caption class="mb-0">
                        Agência: {{ scope.row.agency }}
                    </caption>
                </div>
            </template>
        </el-table-column>
        <el-table-column min-width="90">
            <template slot-scope="scope">
                <div class="d-flex align-items-center">
                    <caption class="mb-0">
                        C/C: {{ scope.row.account }}
                    </caption>
                </div>
            </template>
        </el-table-column>
        <el-table-column min-width="90">
            <template slot-scope="scope" v-if="scope.row.pix">
                <div class="d-flex align-items-center">
                    <caption class="mb-0">
                        PIX: {{ scope.row.pix }}
                    </caption>
                </div>
            </template>
        </el-table-column>
        <el-table-column width="200px" label="">
            <template slot-scope="scope">
                <div class="d-flex justify-content-end align-items-center">
                    <div class="mr-3">
                        <BankAccountStatus :status="scope.row.mainAccount" />
                    </div>
                    <!-- <Button size="small" type="outline" @click="gotoDetails(scope.row)" :color="getPrimaryColor">
                        Acessar
                    </Button> -->
                </div>
            </template>
        </el-table-column>
        <el-table-column width="50" label="buttons">
            <template slot-scope="scope">
                <div>
                    <el-dropdown class="points-dropdown" trigger="click">
                        <span class="">
                            <DropdownIcon />
                        </span>
                        <el-dropdown-menu slot="dropdown">

                            <el-dropdown-item>
                                <span class="c-ndarkthree medium pl-3 d-flex align-items-center" @click="gotoEdit(scope.row)">
                                    <Edit class="mr-2" />Editar
                                </span>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <span class="c-sredfour medium pl-3 d-flex align-items-center" @click="deleteCompany(scope.row.id)">
                                    <TrashIcon color="#E54949" class="mr-2" />Excluir
                                </span>
                            </el-dropdown-item>

                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <ChangeAccount :bankInfo="selectedAccountToChange" :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @changeAccount="requestAccountChange" />
    <AccountDelete :bankInfo="selectedAccountToChange" :dialogVisible="dialogDeleteVisible" @closeModal="dialogDeleteVisible = $event" @deleteAccount="requestDeleteAccount" />
</div>
</template>

<script>
import AlertCheckingAccount from '@/components/icons/AlertCheckingAccount'
import ChangeAccount from '@/components/modals/ChangeAccount'
import AccountDelete from '@/components/modals/AccountDelete'
import BankAccountStatus from '@/components/status/BankAccountStatus'
import DropdownIcon from '@/components/icons/Dropdown'
import Edit from '@/components/icons/Edit'
import TrashIcon from '@/components/icons/Trash'
//import setMainBankAccount from '@/api/setMainBankAccount'
import deleteBankAccount from '@/api/deleteBankAccount'
import userRules from '@/api/userRules'
import banksList from '@/utils/banksList'

export default {
    components: {
        AlertCheckingAccount,
        ChangeAccount,
        AccountDelete,
        Edit,
        TrashIcon,
        DropdownIcon,
        BankAccountStatus,
},
    props: {
        tableData: {
            required: true
        },
        account: {
            required: true
        }
    },
    data() {
        return {
            dialogVisible: false,
            dialogDeleteVisible: false,
            radio: '',
            oldRadioValue: '',
            bankInfo: {
                bank: '',
                bankAgency: '',
                account: '',
            },
            selectedAccountToChange: '',
            selectedAccountToDelete: ''
        }
    },
    methods: {
        tableRowClassName({
            row
        }) {
            if (row.mainAccount == '1') {
                return 'account-border'
            }
            return ''
        },
        bankName(bankCode) {
            const bankEntry = banksList.find(bank => bank.COMPE == bankCode)
            if (bankEntry) {
                return `${bankEntry.COMPE} - ${bankEntry.LongName}`
            } else {
                return ''
            }
        },
        handleRowSelect(row, column) {
            if (column.label != 'buttons') {
                this.selectedAccountToChange = row
                this.dialogVisible = true
            }
        },
        handleChange(row) {
            this.radio = this.oldRadioValue
            this.selectedAccountToChange = row
            this.dialogVisible = true

        },
        async requestAccountChange() {
            this.dialogVisible = false
            // const result = await setMainBankAccount(this.selectedAccountToChange.id)
            // if (result.ok) {
            //     await userRules()
            // }
            this.$emit('change', this.selectedAccountToChange.id)
            this.selectedAccountToChange = ''
        },
        deleteCompany(id) {
            this.dialogDeleteVisible = true
            this.selectedAccountToDelete = id
        },
        async requestDeleteAccount() {
            this.dialogDeleteVisible = false
            await deleteBankAccount(this.selectedAccountToDelete)
            await userRules()
            this.$emit('change')

            this.selectedAccountToDelete = ''
        },
        gotoEdit(row) {
            this.$router.push(`/bank/edit/${row.id}`)
        },
    },
    updated() {
        const account = this.tableData.find(account => account.mainAccount == 1)
        this.radio = account ? account.id : ''
        this.oldRadioValue = account ? account.id : ''
    }
}
</script>

<style>
</style>
